import type { CitationData } from "@/lib/chat-types";
import { CitationBlock } from "./CitationBlock";

interface EvidenceModalProps {
  open: boolean;
  citations: CitationData[];
  onClose: () => void;
}

export function EvidenceModal({ open, citations, onClose }: EvidenceModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center px-4 py-6">
      <div className="absolute inset-0 bg-black/35 backdrop-blur-[2px]" onClick={onClose} />
      <div className="relative z-10 w-full max-w-[700px] overflow-hidden rounded-[22px] border border-[var(--color-border)] bg-[var(--color-surface)] shadow-[0_24px_80px_rgba(15,23,42,0.18)]">
        <div className="flex items-center gap-2 border-b border-[var(--color-border)] px-5 py-5">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" className="text-[var(--color-accent)]">
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2Z" />
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7Z" />
          </svg>
          <h3 className="flex-1 text-[15px] font-semibold text-[var(--color-fg)]" style={{ fontFamily: "var(--font-display)" }}>
            Regulatory References
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-full text-[var(--color-fg-tertiary)] hover:bg-[var(--color-border)]/70 cursor-pointer"
            aria-label="Close evidence preview"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <div className="max-h-[56vh] overflow-y-auto px-4 py-4 sm:px-5">
          <div className="space-y-2.5">
            {citations.map((citation, index) => (
              <CitationBlock key={`${citation.citationId ?? citation.source}-${index}`} citation={citation} compact />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
